import React, { Component } from "react";
import { DndProvider, DragSource } from "react-dnd";
import shortid from "shortid";

import { analytic } from "../../firebase";
// -------------------------
// Create an drag source component that can be dragged into the tree
// https://react-dnd.github.io/react-dnd/docs-drag-source.html
// -------------------------
// This type must be assigned to the tree via the `dndType` prop as well
const externalNodeType = "yourNodeType";
const externalNodeSpec = {
  // This needs to return an object with a property `node` in it.
  // Object rest spread is recommended to avoid side effects of
  // referencing the same object in different trees.
  beginDrag: (componentProps) => {
    if (analytic) {
      analytic.logEvent("element_dragged", {
        name: componentProps.node.tag,
      });
    }
    return {
      node: { ...componentProps.node, id: shortid.generate() },
    };
  },
};
const externalNodeCollect = (connect /* , monitor */) => ({
  connectDragSource: connect.dragSource(),
  // Add props via react-dnd APIs to enable more visual
  // customization of your component
  // isDragging: monitor.isDragging(),
  // didDrop: monitor.didDrop(),
});
class externalNodeBaseComponent extends Component {
  render() {
    const { connectDragSource, node } = this.props;

    return connectDragSource(
      <div className="max-w-sm m-2 flex p-6 rounded-lg shadow cursor-move bg-orange-400 text-white">
        <div class="mx-6 pt-1">
          <h4 class="text-md  leading-tight">
            <label>{node.title}</label>
          </h4>
        </div>
      </div>,
      { dropEffect: "copy" }
    );
  }
}
// externalNodeBaseComponent.propTypes = {
//   node: PropTypes.shape({ title: PropTypes.string }).isRequired,
//   connectDragSource: PropTypes.func.isRequired,
// };
const ExternalDraggableNode = DragSource(
  externalNodeType,
  externalNodeSpec,
  externalNodeCollect
)(externalNodeBaseComponent);

export default ExternalDraggableNode;
